import React from "react";
import styles from "../styles.scss";

export const JsqPrivacyPolicy: React.FunctionComponent = () => {
  return (
    <div id="pp-content">
      <br />
      <p style={{ textAlign: "center", marginBottom: "0px" }}>
        {" "}
        <strong>Juniper Square, Inc.</strong>
      </p>
      <p style={{ textAlign: "center", marginBottom: "0px" }}>
        <strong>Privacy and Cookie Policy</strong>
      </p>
      <br />
      <p style={{ textAlign: "center", marginBottom: "0px" }}>
        {" "}
        <strong>Rev. January 2025</strong>
      </p>
      <br />

      <p>
        This Privacy and Cookie Policy (this “<u>Policy</u>”) describes the ways in which
        Juniper Square, Inc., a Delaware corporation (“<u>Juniper Square</u>”) collects, uses,
        and discloses information about you, including personally identifiable information, in
        connection with your use of the Juniper Square portal, related desktop and mobile
        applications, and the services that Juniper Square provides to you on behalf of sponsors
        of investment funds (“<u>Providers</u>”) (collectively, the “<u>System</u>”). Throughout
        this Policy, “<u>you</u>” refers to the individual or entity that is visiting the
        System. By using the System, you consent to the use of your information as set forth in
        this Policy.
      </p>

      <p>
        1. <strong>This Policy.</strong>
      </p>

      <p className={styles.TermsAndPolicy__legalSubsection}>
        a. <u>Scope</u>. Juniper Square hosts and operates the System on behalf of Providers
        who, together with Juniper Square, utilize the System to provide certain investor
        management and communication services to you (the “<u>Services</u>”). In the course of
        providing the Services on behalf of a Provider, Juniper Square may collect “
        <u>Personal Information</u>
        ,” which means any information relating to an identified or identifiable natural person
        (a “<u>data subject</u>”) (an identifiable natural person is one who can be identified,
        directly or indirectly, in particular by reference to an identifier such as a name, an
        identification number, location data, an online identifier or to one or more factors
        specific to the physical, physiological, genetic, mental, economic, cultural or social
        identity of that natural person). Juniper Square processes your Personal Information to
        perform the Services on behalf of Providers, or as specifically set forth in this
        Policy. Juniper Square is not responsible for the use of your Personal Information by a
        Provider; any such use will be subject to the Provider’s applicable privacy policies and
        terms of use. Providers are able to create their own privacy policies that are more
        strict than Juniper Square’s policies; however, Juniper Square’s privacy policies serve
        as the baseline and minimum of privacy standards.{" "}
      </p>

      <p className={styles.TermsAndPolicy__legalSubsection}>
        b. <u>Changes to this Policy</u>. Juniper Square reserves the right to update this
        Policy from time to time by posting a new Policy on this page, and in some cases where
        changes are material Juniper Square may also contact you via electronic mail or post a
        notice on the homepage to let you know of such changes. You are advised to consult this
        Policy regularly for any changes. Your continued use of the System after such changes
        have been made constitutes acceptance of those changes.
      </p>

      <p>
        2. <strong>Collection of Information.</strong>
      </p>

      <p className={styles.TermsAndPolicy__legalSubsection}>
        a. <u>Information that You Provide</u>. Juniper Square collects any information that you
        voluntarily provide, including when you create an account on the System or when you use
        the Services available through the System. Information that you may provide includes
        your email address, name, phone number, postal address, and online social accounts.
        Juniper Square may also collect information that you provide by electronic mail,
        telephone, or other means when you correspond with Juniper Square directly or with
        Providers via Juniper Square.
      </p>

      <p className={styles.TermsAndPolicy__legalSubsection}>
        b. <u>Automatically Collected Information</u>. Juniper Square may automatically collect
        certain technical information from your computer or mobile device when you use the
        System, such as your Internet Protocol (IP) address, your web browser type and version,
        the name and version of your operating system, the pages you view on the System, the
        inbound links that bring you to the System, the outbound links that direct you out of
        the System, and the search terms you enter on the System. This information allows
        Juniper Square to recognize you and personalize your experience if you return to the
        System using the same computer or mobile device, and to improve the System and the
        Services.
      </p>

      <p className={styles.TermsAndPolicy__legalSubsection}>
        c. <u>Information about Legal and Other Materials</u>. In addition, Juniper Square may
        collect technical information from your computer or mobile device concerning your
        receipt of communications, access to materials, approval or execution of contracts,
        consents or other statements or agreements by means of the System, including the
        System’s Terms of Use and this Policy.
      </p>

      <p className={styles.TermsAndPolicy__legalSubsection}>
        d. <u>Cookies</u>. Juniper Square may collect this information using “cookies,” which
        are small text files that the System saves on your computer or mobile device, or similar
        technologies. You can disable cookies in your browser settings, but doing so may affect
        the functionality of the System. Juniper Square may also collect information using “web
        beacons,” which are clear electronic images that can recognize certain types of
        information on your computer, such as cookies, when you viewed a particular website tied
        to the web beacon, and a description of a website tied to the web beacon or using unique
        links that can distinguish when individual users click the link. Web beacons and unique
        links, alone or in conjunction with cookies, may help Juniper Square compile information
        about your interactions with electronic mail sent to you in connection with the
        Services. For further information, see the Cookie Policy in Section 5 below.{" "}
      </p>

      <p className={styles.TermsAndPolicy__legalSubsection}>
        e. <u>Information We Collect on Behalf of Providers</u>. In providing the Services, we
        process Personal Information on behalf and under the instructions of Providers. We
        process such Personal Information as a service provider or processor (as defined by
        applicable law), on Providers’ behalf. In addition, Juniper Square may collect Personal
        Information about you from other third-party sources. For instance, a Provider that
        invited you to use and/or register an account on the System may facilitate the account
        registration process by uploading certain information about you that is already in the
        Provider’s possession.
      </p>

      <p className={styles.TermsAndPolicy__legalSubsection}>
        f. <u>Cross-Site Tracking</u>. Juniper Square does not utilize technical measures in the
        System to track your activities across different web sites or online services, whether
        you configure your browser’s Do Not Track feature or otherwise. The System does utilize
        third-party application programming interfaces controlled by third parties, such as to
        display maps and graphs, that may attempt to track your activity across other sites that
        utilize those interfaces.
      </p>

      <p className={styles.TermsAndPolicy__legalSubsection}>
        g. <u>Reviewing and Correcting Information</u>. You may update or correct contact
        information and other Personal Information stored about you on the System by accessing
        your account/profile page, or by sending a written request to the Provider that provides
        Services to you via the System.{" "}
      </p>

      <p>
        3. <strong>Use and Disclosure of Information.</strong> Juniper Square may collect, use,
        share, and otherwise process your personal information for a number of purposes,
        including, but not limited to:
      </p>
      <p className={styles.TermsAndPolicy__legalSubsection}>
        a. <u>Accessing the System and Providing the Services.</u> Juniper Square uses your
        Personal Information to provide you with the Services, or products, services or
        information related to the System or the Services; providing you with information about
        the System, Services, or required notices; customizing your experience when using the
        System, such as by providing you with interactive or personalized elements on the System
        based on your usage and needs. The legal basis for such use are the System’s Terms of
        Use and this Policy.
      </p>
      <p className={styles.TermsAndPolicy__legalSubsection}>
        b. <u>Analysis.</u> Juniper Square uses your Personal Information for improving the
        System and/or the Services, including by (i) combining or aggregating any of the
        information collected through the System or elsewhere for generating and analyzing
        statistics about your use of the System and user demographics and traffic patterns and
        (ii) using anonymized data that may or may not be derived from Personal Information but
        does not personally identify you, both for disclosure to third parties and for the
        purpose of enhancing the Services and developing new Service offerings. Juniper Square
        does not attempt, nor is able, to re-identify individuals based on aggregated and
        anonymized data. The legal basis for such use are the System’s Terms of Use and this
        Policy and Juniper Square’s legitimate interest in improving the System and Services.
      </p>
      <p className={styles.TermsAndPolicy__legalSubsection}>
        c. <u>Marketing.</u> If you submit your information to a Provider via Juniper Square,
        the Provider may provide you with information about the System, Services or required
        notices. In addition, the Provider may use collected information for delivering
        marketing communications that may be of interest to you. Juniper Square makes Personal
        Information about you available to the Providers who provide Services to you via the
        System, but does not otherwise sell or share your Personal Information with other
        companies so that they can market to you. You have the right to ask the Provider not to
        process your Personal Information for marketing purposes and Juniper Square will
        cooperate with the Provider in accommodating such request.
      </p>
      <p className={styles.TermsAndPolicy__legalSubsection}>
        d. <u>Security.</u> Juniper Square may use your Personal Information for safety and
        security purposes, including sharing of your information for such purposes, when it is
        necessary to pursue Juniper Square’s legitimate interests in ensuring the security of
        the System and Services, including detecting, preventing and responding to fraud,
        intellectual property infringement, violations of the System’s Terms of Use, violations
        of law or other misuse of the System; and when Juniper Square believes in good faith
        that disclosure is necessary (A) to protect Juniper Square’s rights, the rights of
        Providers or other users of the System, the integrity of the System, or your safety or
        the safety of others, or (B) to detect, prevent, or respond to fraud, intellectual
        property infringement, violations of the System’s Terms of Use, violations of law, or
        other misuse of the System.
      </p>
      <p className={styles.TermsAndPolicy__legalSubsection}>
        e. <u>Service Providers.</u> Juniper Square engages third-party service providers (such
        as payment processors, hosting providers, analytics, and security providers) to assist
        in operating and marketing the System. Juniper Square’s engagement of third-party
        service providers is often necessary for Juniper Square to provide the Services to you,
        particularly where such third-party service providers ensure that the System and
        Services are operating and secure. In other cases, Juniper Square has a legitimate
        interest in third-party service providers that can help improve the System and the
        Service.
      </p>
      <p className={styles.TermsAndPolicy__legalSubsection}>
        f. <u>Other Disclosure.</u> Juniper Square may disclose Personal Information about you
        to others: (a) if Juniper Square has your valid consent to do so; (b) to comply with a
        valid subpoena, legal order, court order, legal process, or other legal obligation; (c)
        to enforce any of the Juniper Square terms and conditions or policies; or (d) as
        necessary to pursue available legal remedies or defend legal claims. Juniper Square may
        also transfer your Personal Information to an affiliate, a subsidiary or a third party
        in the event of any reorganization, merger, acquisition or sale, joint venture,
        assignment, transfer or other disposition of all or any portion of Juniper Square’s
        business, assets or stock, including, without limitation, in connection with any
        bankruptcy or similar proceeding, provided that any such entity that Juniper Square
        transfer Personal Information to will not be permitted to process your Personal
        Information other than as described in this Policy without providing you notice and, if
        required by applicable laws, obtaining your consent.
      </p>

      <p>
        4. <strong>Storage.</strong>
      </p>

      <p className={styles.TermsAndPolicy__legalSubsection}>
        a. <u>Jurisdiction.</u> Information collected through the System will be stored in,
        processed in, and subject to the laws of the United States, which may not provide the
        same level of protection for your information as your home country, and may be available
        to the United States government or its agencies under a lawful order made in the United
        States. By using the System, you consent to such transfer to, storage in, and processing
        within the United States.
      </p>

      <p className={styles.TermsAndPolicy__legalSubsection}>
        b. <u>Security.</u> Juniper Square is committed to protecting your information from
        unauthorized access, use or disclosure. The system and its operators maintain
        administrative, technical and physical safeguards designed to protect the information
        collected through the System. For example, all information you transmit to the System is
        encrypted using Transport Layer Security technology (TLS). However, no information or
        communication system can be 100% secure, so Juniper Square cannot guarantee the absolute
        security of your information. In addition, Juniper Square is not responsible for the
        security of information that you transmit to the System over networks that Juniper
        Square does not control, including the Internet and wireless networks.
      </p>

      <p className={styles.TermsAndPolicy__legalSubsection}>
        c. <u>Retention.</u> Juniper Square will not retain data longer than is necessary to
        fulfill the purposes for which it was collected or as required by applicable laws or
        regulations. If you wish to access or correct any information Juniper Square holds about
        you, you may have your data deleted, blocked or corrected (as long as compliant with
        applicable law). Where Juniper Square processes your Personal Information on behalf of a
        Provider as a service provider or processor, Juniper Square will retain such information
        in line with the Provider’s instructions and Juniper Square’s contractual obligations.
        You may have the right to ask the Provider to delete, block or correct such Personal
        Information and Juniper Square will cooperate with the Provider in accommodating such
        request.{" "}
      </p>

      <p>
        5. <strong>Cookie Policy.</strong> This section provides Juniper Square’s cookie policy
        and describes how Juniper Square uses Cookies and similar technologies.
      </p>
      <p className={styles.TermsAndPolicy__legalSubsection}>
        a. <u>Cookies.</u> Cookies are small pieces of data that are stored on your computer,
        mobile phone, or other device when you first visit a page. Juniper Square uses cookies,
        web beacons and similar technologies (“Cookies”) to enable your user experience and to
        understand your usage of the System and Services. Cookies may also be set by other
        websites or services that provide or host content on the page you are visiting. The
        provision of your data via Cookies is voluntary except for those Cookies that Juniper
        Square places on your device because it is necessary for the performance of the System
        or Services. Juniper Square uses “session Cookies” and “persistent Cookies.” Session
        Cookies are temporary Cookies that remain on your device until you leave the System or
        Services. A persistent Cookie may remain on your device for much longer until you
        manually delete it, or it automatically expires.
      </p>
      <p className={styles.TermsAndPolicy__legalSubsection}>
        b. <u>Use.</u> Cookies can contain the following information about you and your use of
        the System: browser type, search preferences, data relating to which pages of the System
        that you have visited and the date and time of your use. Juniper Square uses Cookies for
        the following purposes:
      </p>

      <p className={styles.TermsAndPolicy__legalSubsubsection}>
        i. To enable and support security features, prevent fraud, and protect your data from
        unauthorized access.
      </p>
      <p className={styles.TermsAndPolicy__legalSubsubsection}>
        ii. To enable features and help us provide you with personalized content.
      </p>

      <p className={styles.TermsAndPolicy__legalSubsection}>
        c. <u>Third-Party Cookies.</u> Juniper Square uses the following third-party Cookies on
        the System:
      </p>
      <p className={styles.TermsAndPolicy__legalSubsubsection}>
        <strong>i. DocuSign (if applicable).</strong> Our application provides the option to
        execute agreements via DocuSign. If you interact with DocuSign via our application, you
        may encounter Cookies used by DocuSign in their internal operations. See{" "}
        <a href="https://www.docusign.com/company/privacy-policy">
          https://www.docusign.com/company/privacy-policy
        </a>{" "}
        for details.
      </p>
      <p className={styles.TermsAndPolicy__legalSubsubsection}>
        <strong>ii. Wistia, YouTube, and Vimeo.</strong> Our application provides the capability
        to embed video from Wistia, YouTube, or Vimeo as part of a Provider’s offering of
        marketing materials. We have configured this capability so that it uses the
        “privacy-enhanced” or “do not track” mode of each of these three services. In this mode,
        the services may set Cookies on your computer once you interact with the video player,
        but they will not store personally identifiable Cookie information for playbacks of
        embedded video. Read more about the privacy-enhanced mode for Wistia video at{" "}
        <a href="https://wistia.com/support/developers/player-privacy-mode">
          https://wistia.com/support/developers/player-privacy-mode
        </a>
        , for YouTube video at{" "}
        <a href="https://support.google.com/youtube/answer/171780?hl=en">
          https://support.google.com/youtube/answer/171780?hl=en
        </a>
        , and for Vimeo video at{" "}
        <a href="https://vimeo.zendesk.com/hc/en-us/articles/360001494447-Using-Player-Parameters">
          https://vimeo.zendesk.com/hc/en-us/articles/360001494447-Using-Player-Parameters
        </a>
        . See also <a href="https://wistia.com/privacy">https://wistia.com/privacy</a>,{" "}
        <a href="https://policies.google.com/privacy">https://policies.google.com/privacy</a>,
        and <a href="https://vimeo.com/privacy">https://vimeo.com/privacy</a> for additional
        details about the privacy practices of these services.
      </p>
      <p className={styles.TermsAndPolicy__legalSubsubsection}>
        iii. <strong>Zendesk.</strong> Juniper Square provides help materials via an integration
        with Zendesk. When you use our help center, you are interacting with a third-party
        website not controlled by Juniper Square and may encounter Cookies used by Zendesk in
        their internal operations. See{" "}
        <a href="https://www.zendesk.com/company/customers-partners/privacy-policy/">
          https://www.zendesk.com/company/customers-partners/privacy-policy/
        </a>{" "}
        for details.
      </p>
      <p className={styles.TermsAndPolicy__legalSubsubsection}>
        iv. <strong>Skilljar.</strong> Juniper Square utilizes the Skilljar platform to host our
        customer education material, and Skilljar uses Cookies to track the usage of that
        material. See{" "}
        <a href="https://www.skilljar.com/privacy/">https://www.skilljar.com/privacy/</a> for
        more details.
      </p>
      <p className={styles.TermsAndPolicy__legalSubsubsection}>
        v. <strong>Wistia.</strong> Wistia also hosts the video content embedded in both our
        help center and our customer education material. We have implemented this functionality
        so that it uses Wistia’s privacy-enhanced mode. In this mode the website may set Cookies
        on your computer once you click on the video player, but it will not store
        personally-identifiable Cookie information for playbacks of embedded videos. Read more
        about Wistia’s privacy-enhanced mode at{" "}
        <a href="https://wistia.com/support/developers/player-privacy-mode">
          https://wistia.com/support/developers/player-privacy-mode
        </a>
        , and see <a href="https://wistia.com/privacy">https://wistia.com/privacy</a> for
        additional details.
      </p>
      <p className={styles.TermsAndPolicy__legalSubsection}>
        d. <u>Opting Out.</u> You can control and/or delete Cookies as you wish – for details,
        see <a href="https://www.aboutcookies.org/">https://www.aboutcookies.org/</a>. You can
        delete all Cookies that are already on your computer and you can set most browsers to
        prevent them from being placed. If you do this, however, you may have to manually adjust
        some preferences every time you visit a site and some services and functionalities may
        not work as intended by Juniper Square.{" "}
      </p>
      <p>
        6. <strong>GDPR.</strong>
      </p>
      <p className={styles.TermsAndPolicy__legalSubsection}>
        a. If you are a resident of the European Economic Area or the United Kingdom, Juniper
        Square will process your Personal Information in compliance with the EU General Data
        Protection Regulation (“GDPR”) and relevant UK laws and regulations.{" "}
      </p>
      <p className={styles.TermsAndPolicy__legalSubsection}>
        b. Juniper Square, Inc. is a controller (as defined under GDPR), for certain Personal
        Information that you provide when you use the Service. For instance, your account
        information used to access the Service, automatically collected information about your
        use of the Service and cookie data. In accordance with GDPR, where Juniper Square
        processes your Personal Information as a controller, in certain circumstances you will
        have certain rights, which may include the following:
      </p>
      <p className={styles.TermsAndPolicy__legalSubsubsection}>i. right of confirmation;</p>
      <p className={styles.TermsAndPolicy__legalSubsubsection}>ii. right of access;</p>
      <p className={styles.TermsAndPolicy__legalSubsubsection}>iii. right to rectification;</p>
      <p className={styles.TermsAndPolicy__legalSubsubsection}>iv. right to erasure;</p>
      <p className={styles.TermsAndPolicy__legalSubsubsection}>
        v. right of restriction of processing;
      </p>
      <p className={styles.TermsAndPolicy__legalSubsubsection}>
        vi. right to data portability;
      </p>
      <p className={styles.TermsAndPolicy__legalSubsubsection}>vii. right to object; </p>
      <p className={styles.TermsAndPolicy__legalSubsubsection}>
        viii. right to withdraw data protection consent; and
      </p>
      <p className={styles.TermsAndPolicy__legalSubsubsection}>
        ix. the right to lodge a complaint with a supervisory authority.
      </p>

      <p className={styles.TermsAndPolicy__legalSubsection}>
        c. For Personal Information that Juniper Square processes on behalf of Providers,
        Juniper Square is a processor, as defined under GDPR. Juniper Square is not responsible
        for and has no control over the privacy and data security practices of Providers, which
        may differ from those explained in this Policy. The data protection rights listed above
        do not apply to Juniper Square where Juniper Square processes Personal Information as a
        processor on behalf of a Provider. If Juniper Square processes your Personal Information
        as a processor on behalf of a Provider, and you wish to exercise any rights you may have
        under the GDPR or other applicable data protection laws, please inquire with the
        Provider directly.
      </p>

      <p>
        7.{" "}
        <strong>
          Notice to California Residents: California Consumer Privacy Act, as amended.
        </strong>
      </p>

      <p>As of January 1, 2023, verified California residents have the right to:</p>

      <p>
        a. request and receive disclosure of our personal information collection practices
        during the prior 12 months, including the categories of personal information we collect,
        the categories of sources of such information, our business purpose for collecting or
        sharing such information, and the categories of third parties with whom we share such
        information;
      </p>
      <p>
        b. request and receive a copy of the personal information we have collected about them
        during the prior 12 months;
      </p>
      <p>
        c. request and receive disclosure of our information sharing practices during the prior
        12 months, including a list of the categories of personal information sold with the
        category of third party recipients and a list of the categories of personal information
        that we disclosed for a business purpose;
      </p>
      <p>d. request that we not sell personal information about them; </p>
      <p>
        e. request that we delete (and direct our service providers to delete) their personal
        information subject to certain exceptions;
      </p>
      <p>
        f. request that we correct inaccurate personal information we may have about you; and
      </p>
      <p>g. request that we limit the use and disclosure of sensitive personal information.</p>

      <p>
        h. For the purposes of this Section 7, “personal information” has the meaning given in
        the California Consumer Privacy Act (“CCPA”) as amended, but does not include certain
        de-identified or aggregated information, information publicly available in government
        records, or certain information excluded from the CCPA’s scope;
      </p>

      <p>
        i. In order to make a request for disclosure California residents may contact us at{" "}
        <a href="mailto:privacy@junipersquare.com">privacy@junipersquare.com</a>. We will ask
        you for information that allows us to reasonably verify your identity (that you are the
        person about whom we collected personal information) and will use that information only
        for that purpose. We may request that you submit a signed statement under penalty of
        perjury that you are the individual you claim to be. We will acknowledge receipt of your
        request within 10 days and will endeavor to respond within forty-five days of receipt of
        your request, but if we require more time (up to an additional forty-five days) we will
        notify you of our need for additional time. For requests that we not sell your
        information, we will comply with your request within 15 days. We cannot respond to your
        request or provide you with personal information if we cannot verify your identity and
        confirm that the personal information relates to you.
      </p>

      <p>
        j. You may make a request for disclosure of our information collection practices, the
        information we collected about you, or our sharing practices up to twice within a
        12-month period. You may make a request that we not sell information or for deletion of
        your information at any time.
      </p>

      <p>
        k. For requests for a copy of the personal information we have collected during the 12
        months prior to your request, we will endeavor to provide the information in a format
        that is readily useable, including by mailing you a paper copy or providing an
        electronic copy to your registered account, if you have registered an account with us.
      </p>

      <p>
        l. For requests for deletion of your information, please understand that California law
        permits us to retain certain information and not to delete it under certain
        circumstances. By way of example, we are not required to comply with a request to delete
        information if the information is necessary for us to complete a transaction for you or
        otherwise perform a contract; to detect, protect against, or prosecute security
        incidents, fraud or illegal activity; to use the information only internally in ways
        reasonably aligned with your expectations as our customer (such as maintaining sales
        records), and to comply with legal obligations. If we receive such a request from you,
        we will notify any service providers we have engaged to delete your information as well.
      </p>
      <p>
        m. We will not discriminate against you as a result of your exercise of any of these
        rights.{" "}
      </p>
      <p>
        n. <u>Selling Information.</u> We do not sell, share, or disclose your information to
        third parties for monetary or other valuable consideration. If, in the future, we enter
        into arrangements that fall within the definition of a “sale” or “share” under the CCPA
        as amended, we will update this privacy policy and our compliance with the CCPA as
        amended.
      </p>
      <p>
        o. <u>Using an Authorized Agent.</u> You may submit a request through someone holding a
        formal Power of Attorney. Otherwise, you may submit a request using an authorized agent
        only if (1) you provide the authorized agent with written permission to make a request
        and (2) you verify your own identity directly with us. We will require the agent to
        submit proof to us that they have been authorized to make requests on your behalf.
      </p>
      <p>
        p. During the past 12 months, we have collected the following categories of information
        from the listed sources, used it for the listed business purposes, and shared it with
        the listed categories of third parties. The business purposes for which we collect the
        Personal Information are described in Section 3 above. The categories include
        information we collect from visitors to our website that may be accessed via{" "}
        <a href="https://www.junipersquare.com">https://www.junipersquare.com</a>, or from
        registered users, employees, vendors, suppliers and any other person that interacts with
        us either online or offline. Not all information is collected about all individuals. For
        instance, we may collect different information from applicants for employment or from
        vendors or from customers.
      </p>

      <table
        id="cookie-list"
        style={{ borderWidth: "1px", borderStyle: "solid", marginBottom: "25px" }}
      >
        <tbody>
          <tr style={{ borderWidth: "1px", borderStyle: "solid" }}>
            <td style={{ padding: "5px", borderWidth: "1px", borderStyle: "solid" }}>
              <p>
                <strong>Category of Personal Information (PI) collected</strong>
              </p>
            </td>
            <td style={{ padding: "5px", borderWidth: "1px", borderStyle: "solid" }}>
              <p>
                <strong>Sources of PI</strong>
              </p>
            </td>
            <td style={{ padding: "5px", borderWidth: "1px", borderStyle: "solid" }}>
              <p>
                <strong>Purposes of collecting PI</strong>
              </p>
            </td>
            <td style={{ padding: "5px", borderWidth: "1px", borderStyle: "solid" }}>
              <p>
                <strong>Categories of third parties to whom we disclose PI</strong>
              </p>
            </td>
          </tr>
          <tr style={{ borderWidth: "1px", borderStyle: "solid" }}>
            <td style={{ padding: "5px", borderWidth: "1px", borderStyle: "solid" }}>
              <p>
                Identifiers such as full name, date of birth, nationality, gender, email
                address, phone number or postal address
              </p>
            </td>
            <td style={{ padding: "5px", borderWidth: "1px", borderStyle: "solid" }}>
              <p>
                Information you provide us; information collected from third parties;
                information we may receive from third-party marketing and data partners.
              </p>
            </td>
            <td style={{ padding: "5px", borderWidth: "1px", borderStyle: "solid" }}>
              <p>
                To maintain legal and regulatory compliance; audit transactions; security
                detection, protection and enforcement; functionality debugging/error repair;
                customize user experience; perform services for you; engage in marketing
                activities; internal research and development.
              </p>
            </td>
            <td style={{ padding: "5px", borderWidth: "1px", borderStyle: "solid" }}>
              <p>
                Service providers (such as payment processors, marketing partners, employee
                benefits partners; identity verification providers); government regulators; law
                enforcement.
              </p>
            </td>
          </tr>
          <tr style={{ borderWidth: "1px", borderStyle: "solid" }}>
            <td style={{ padding: "5px", borderWidth: "1px", borderStyle: "solid" }}>
              <p>
                Sensitive Information such as government issued identity document such as
                passport, driver’s license, national identity card, state ID card, tax ID
                number, passport number, driver’s license details, national identity card
                details, visa information, and/or any other information deemed necessary to
                comply with legal obligations under applicable financial regulation and law
              </p>
            </td>
            <td style={{ padding: "5px", borderWidth: "1px", borderStyle: "solid" }}>
              <p>Information you provide us; information collected from third parties.</p>
            </td>
            <td style={{ padding: "5px", borderWidth: "1px", borderStyle: "solid" }}>
              <p>
                To maintain legal and regulatory compliance; audit transactions; security
                detection, protection and enforcement; functionality debugging/error repair;
                customize user experience; perform services for you; internal research and
                development.
              </p>
            </td>
            <td style={{ padding: "5px", borderWidth: "1px", borderStyle: "solid" }}>
              <p>
                Service providers (such as payment processors, employee benefits partners;
                identity verification providers); government regulators; law enforcement.
              </p>
            </td>
          </tr>
          <tr style={{ borderWidth: "1px", borderStyle: "solid" }}>
            <td style={{ padding: "5px", borderWidth: "1px", borderStyle: "solid" }}>
              <p>
                Commercial information such as bank account information, payment card primary
                account number (PAN), transaction history, and/or tax identification number
              </p>
            </td>
            <td style={{ padding: "5px", borderWidth: "1px", borderStyle: "solid" }}>
              <p>
                Information you provide us; Information collected from third parties;
                information we may receive from third-party marketing or data partners.
              </p>
            </td>
            <td style={{ padding: "5px", borderWidth: "1px", borderStyle: "solid" }}>
              <p>
                To maintain legal and regulatory compliance; audit transactions; security
                detection, protection and enforcement; functionality debugging/error repair;
                customize user experience; perform services for you; internal research and
                development.
              </p>
            </td>
            <td style={{ padding: "5px", borderWidth: "1px", borderStyle: "solid" }}>
              <p>
                Service providers (such as payment processors, employee benefits partners);
                government regulators; law enforcement.
              </p>
            </td>
          </tr>
          <tr style={{ borderWidth: "1px", borderStyle: "solid" }}>
            <td style={{ padding: "5px", borderWidth: "1px", borderStyle: "solid" }}>
              <p>
                Electronic network activity such as browsing or search history, IP address,
                website interactions and advertisement interactions
              </p>
            </td>
            <td style={{ padding: "5px", borderWidth: "1px", borderStyle: "solid" }}>
              <p>Information automatically collected from visitors to our website.</p>
            </td>
            <td style={{ padding: "5px", borderWidth: "1px", borderStyle: "solid" }}>
              <p>
                Audit transactions; security detection, protection and enforcement;
                functionality debugging/error repair; customize user experience; perform
                services for you; engage in marketing activities; internal research and
                development.
              </p>
            </td>
            <td style={{ padding: "5px", borderWidth: "1px", borderStyle: "solid" }}>
              <p>
                Service providers (such as payment processors, marketing partners, employee
                benefits partners); government regulators; law enforcement.
              </p>
            </td>
          </tr>
          <tr style={{ borderWidth: "1px", borderStyle: "solid" }}>
            <td style={{ padding: "5px", borderWidth: "1px", borderStyle: "solid" }}>
              <p>
                Audio, video, photographs or similar information such as customer service calls
              </p>
            </td>
            <td style={{ padding: "5px", borderWidth: "1px", borderStyle: "solid" }}>
              <p>Information you provide us; information we collect for security purposes.</p>
            </td>
            <td style={{ padding: "5px", borderWidth: "1px", borderStyle: "solid" }}>
              <p>
                Audit transactions; security detection, protection and enforcement;
                functionality debugging/error repair; customize user experience; perform
                services for you; engage in marketing activities; internal research and
                development.
              </p>
            </td>
            <td style={{ padding: "5px", borderWidth: "1px", borderStyle: "solid" }}>
              <p>
                Service providers (such as payment processors and marketing partners);
                government regulators; law enforcement.
              </p>
            </td>
          </tr>
          <tr style={{ borderWidth: "1px", borderStyle: "solid" }}>
            <td style={{ padding: "5px", borderWidth: "1px", borderStyle: "solid" }}>
              <p>
                Professional, educational or employment related information including office
                location, job title, and/or description of role
              </p>
            </td>
            <td style={{ padding: "5px", borderWidth: "1px", borderStyle: "solid" }}>
              <p>
                Information you provide us; information collected from third parties;
                information we observe in connection with vendor or employee oversight.
              </p>
            </td>
            <td style={{ padding: "5px", borderWidth: "1px", borderStyle: "solid" }}>
              <p>
                To maintain legal and regulatory compliance; to review and process your
                employment applications; to engage in marketing activities.
              </p>
            </td>
            <td style={{ padding: "5px", borderWidth: "1px", borderStyle: "solid" }}>
              <p>
                Service providers (such as employee benefits partners and identity verification
                providers).
              </p>
            </td>
          </tr>
          <tr style={{ borderWidth: "1px", borderStyle: "solid" }}>
            <td style={{ padding: "5px", borderWidth: "1px", borderStyle: "solid" }}>
              <p>
                Inferences drawn from the above about your preferences, characteristics, etc.
              </p>
            </td>
            <td style={{ padding: "5px", borderWidth: "1px", borderStyle: "solid" }}>
              <p>Internal analytics</p>
            </td>
            <td style={{ padding: "5px", borderWidth: "1px", borderStyle: "solid" }}>
              <p>To engage in marketing activities; internal research and development.</p>
            </td>
            <td style={{ padding: "5px", borderWidth: "1px", borderStyle: "solid" }}>
              <p>Service providers (such as marketing partners).</p>
            </td>
          </tr>
        </tbody>
      </table>

      <p>
        As described above, we may also act as a service provider or processor to Providers who
        use our technology to process your Personal Information. We are not responsible for and
        have no control over the privacy and data security practices of such Providers, which
        may differ from those explained in this Policy. If your data has been submitted to us by
        or on behalf of a Provider and you wish to exercise any rights you may have under
        applicable data protection laws, please inquire with them directly.
      </p>

      <p>
        8. <strong>Third-Party Websites.</strong> The System and communications from Juniper
        Square may contain links to websites operated by third parties, including sites operated
        by Providers. You acknowledge and agree that Juniper Square is not responsible for the
        collection and use of your information by such websites that are not under Juniper
        Square’s control. Juniper Square encourages you to review the privacy policies of each
        website you visit.
      </p>

      <p>
        9. <strong>Children’s Information.</strong> The System is not directed to, nor does
        Juniper Square knowingly collect information from, children under the age of 13. If you
        become aware that your child or any child under your care has provided information
        without your consent, please contact Juniper Square immediately using the contact
        information provided below.
      </p>

      <p>
        10. <strong>Other Agreements.</strong> You may from time to time enter into binding
        legal agreements relating to certain Services available through the System, which may
        have terms that are different from those of this Policy. In the event of any
        inconsistency, the terms of such other agreement shall control with respect to such
        Services.
      </p>

      <p>
        11. <strong>Contact Information.</strong> If you have any questions about this Policy or
        the collection or use of information about you, please write to your Provider or to
        Juniper Square at{" "}
        <a href="mailto:privacy@junipersquare.com">privacy@junipersquare.com</a> or 555
        Montgomery Street, 14th Floor, San Francisco, CA 94111.
      </p>
    </div>
  );
};

export default JsqPrivacyPolicy;
